import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a91ac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-6 pb-4 mx-6 modal-size" }
const _hoisted_2 = { class: "w-full flex items-center justify-center px-6" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "px-6"
}
const _hoisted_5 = { class: "flex mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonacoEditorFreeSpace = _resolveComponent("MonacoEditorFreeSpace")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_InputConsole = _resolveComponent("InputConsole")!
  const _component_OutputConsole = _resolveComponent("OutputConsole")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, { onClickBackground: _ctx.onClose }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MonacoEditorFreeSpace, { class: "min-h-0 w-full h-full border select-none dark:border-dark-200" })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: _normalizeClass(["relative mb-2 focus:outline-none font-bold shadow-md border-2 hover:border-gray-600 hover:text-gray-600 bg-white border-gray-700 text-gray-700 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text dark:hover:border-dark-10 dark:hover:bg-dark-10", {
            'base-texticon-click-effect': _ctx.isLightMode(),
            'base-texticon-click-effect-dark': !_ctx.isLightMode()
          }]),
            disabled: _ctx.isTestLoading,
            style: {"width":"100px","height":"30px","border-radius":"1rem"},
            type: "submit",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickTestSubmit && _ctx.clickTestSubmit(...args)))
          }, _toDisplayString(_ctx.isTestLoading ? '' : _ctx.$t('message.run')), 11, _hoisted_3)
        ]),
        (
          _ctx.freeSpaceState.isErrorShow.value &&
          !_ctx.isTestLoading &&
          _ctx.freeSpaceJudgeDetailState.judgeDetail.value &&
          (_ctx.freeSpaceJudgeDetailState.judgeDetail.value.compileError ||
            _ctx.freeSpaceJudgeDetailState.judgeDetail.value.runtimeError)
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_ErrorMessage, {
                errorText: _ctx.freeSpaceState.errorMessage.value,
                testJudgeDetail: _ctx.freeSpaceJudgeDetailState.judgeDetail.value
              }, null, 8, ["errorText", "testJudgeDetail"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_InputConsole, {
            class: "p-2",
            isEditable: !_ctx.isTestLoading,
            label: _ctx.$t('message.input'),
            onChange: _ctx.freeSpaceState.setTestInput,
            value: _ctx.freeSpaceState.testInput.value
          }, null, 8, ["isEditable", "label", "onChange", "value"]),
          _createVNode(_component_OutputConsole, {
            class: "p-2",
            isEditable: false,
            label: _ctx.$t('message.output')
          }, null, 8, ["label"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClickBackground"]))
}